import "core-js/modules/es.array.concat.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import AccountConfirmationDialog from '@/components/renewal/dialog/account-confirmation-dialog.vue';
import NewsPanel from '@/components/renewal/news/news-panel.vue';
import CollectionPanel from '@/components/renewal/collection/collection-panel.vue';
import BookPanel from '@/components/renewal/book/book-panel.vue';
import FormatPanel from '@/components/renewal/format/format-panel.vue';
import BannerPanel from '@/components/renewal/banner/banner-panel.vue';
import StorePanel from '@/components/renewal/store/store-panel.vue';
import { useAuth } from '@/plugins/auth';
import { useStore } from '@/store/useStore';
import { Organization } from '@/constants';
import 'design-system/tokens';
export default /*#__PURE__*/_defineComponent({
  __name: 'top',
  setup: function setup(__props) {
    var auth = useAuth();
    var store = useStore();
    var panels = ref(null);

    // ドメインと権限による表示の制御
    var showNewsPanel = computed(function () {
      return store.state.persistent.showNewsPanel && auth.permissions.practiceArea;
    });
    var showCollectionPanel = computed(function () {
      return auth.permissions.quickAccess;
    });
    var showBookPanel = computed(function () {
      return auth.user.organization.oid !== Organization.PERSONAL_OID;
    });
    var showFormatPanel = computed(function () {
      return auth.permissions.formatDownload;
    });
    var showStorePanel = computed(function () {
      return auth.permissions.oneTimePurchase;
    });
    var layout = function layout() {
      var panelsElement = panels.value;
      if (!panelsElement) return;
      var firstRow = showNewsPanel.value ? 'news' : showBookPanel.value ? 'book' : '.';
      panelsElement.style.gridTemplateAreas = "\n  \"".concat(firstRow, " collection\"\n  \"").concat(showBookPanel.value ? 'book' : '.', " ").concat(showBookPanel.value ? 'format' : 'banner', "\"\n  \"").concat(showBookPanel.value ? 'book' : '.', " ").concat(showBookPanel.value ? 'banner' : 'store', "\"\n  \"").concat(showBookPanel.value ? 'book' : '.', " ").concat(showBookPanel.value && showStorePanel.value ? 'store' : '.', "\"\n  \"").concat(showBookPanel.value ? 'book' : '.', " .\"\n  ");
    };
    watch([showNewsPanel, showBookPanel, showStorePanel], function () {
      layout();
    });
    onMounted(function () {
      layout();
    });
    return {
      __sfc: true,
      auth: auth,
      store: store,
      panels: panels,
      showNewsPanel: showNewsPanel,
      showCollectionPanel: showCollectionPanel,
      showBookPanel: showBookPanel,
      showFormatPanel: showFormatPanel,
      showStorePanel: showStorePanel,
      layout: layout,
      AccountConfirmationDialog: AccountConfirmationDialog,
      NewsPanel: NewsPanel,
      CollectionPanel: CollectionPanel,
      BookPanel: BookPanel,
      FormatPanel: FormatPanel,
      BannerPanel: BannerPanel,
      StorePanel: StorePanel
    };
  }
});